import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { brl, fmtQty, UNIT_LABELS } from "@/lib/api";

const ACTIONS = [["existing", "Dar entrada em item já cadastrado"], ["new_product", "Cadastrar como produto novo"], ["new_ingredient", "Cadastrar como insumo novo"], ["skip", "Ignorar este item"]];

function Sel({ value, onChange, children, testId }) {
  return <select value={value} onChange={(e) => onChange(e.target.value)} className="h-10 w-full rounded-md border bg-transparent px-2 text-sm" data-testid={testId}>{children}</select>;
}

function LinkTarget({ r, idx, catalog, onChange }) {
  return (
    <Field label="Item do cadastro">
      <Sel value={r.item_id ? `${r.kind}:${r.item_id}` : ""} onChange={(v) => { const [kind, item_id] = v.split(":"); onChange({ kind: kind || "product", item_id: item_id || "" }); }} testId={`nfe-item-link-${idx}`}>
        <option value="">Escolha o produto ou insumo…</option>
        <optgroup label="Produtos">{catalog.products.map((p) => <option key={p.id} value={`product:${p.id}`}>{p.name}</option>)}</optgroup>
        <optgroup label="Insumos">{catalog.ingredients.map((x) => <option key={x.id} value={`ingredient:${x.id}`}>{x.name}</option>)}</optgroup>
      </Sel>
    </Field>
  );
}

function NewTarget({ r, idx, catalog, onChange }) {
  const isProduct = r.action === "new_product";
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <Field label={isProduct ? "Nome do produto" : "Nome do insumo"} className="sm:col-span-3"><Input value={r.name} onChange={(e) => onChange({ name: e.target.value })} data-testid={`nfe-item-name-${idx}`} /></Field>
      <Field label="Unidade"><Sel value={r.unit} onChange={(v) => onChange({ unit: v })} testId={`nfe-item-unit-${idx}`}>{Object.entries(UNIT_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</Sel></Field>
      {isProduct && <Field label="Preço de venda (R$)"><Input type="number" step="0.01" min="0" value={r.price} onChange={(e) => onChange({ price: e.target.value })} data-testid={`nfe-item-price-${idx}`} /></Field>}
      {isProduct && <Field label="Categoria"><Sel value={r.category_id} onChange={(v) => onChange({ category_id: v })} testId={`nfe-item-category-${idx}`}><option value="">Geral</option>{catalog.categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</Sel></Field>}
    </div>
  );
}

function Summary({ r, idx, catalog }) {
  const f = Number(r.factor) || 1;
  const target = r.action === "existing" ? [...catalog.products, ...catalog.ingredients].find((x) => x.id === r.item_id) : null;
  const unit = r.action === "existing" ? target?.unit || "un" : r.unit;
  const how = r.match && r.action === "existing" && r.item_id === r.match.id ? ` · reconhecido pelo ${r.match.by === "barcode" ? "código de barras" : "nome"}` : "";
  return <p className="text-xs text-emerald-600 dark:text-emerald-400" data-testid={`nfe-item-summary-${idx}`}>Entrada de {fmtQty(r.qty * f)} {unit} a {brl(r.unit_cost / f)} cada{how}</p>;
}

export function NfeItemRow({ r, idx, catalog, onChange }) {
  const skip = r.action === "skip";
  return (
    <div className={`space-y-3 rounded-xl border p-4 transition-opacity ${skip ? "opacity-50" : ""}`} data-testid={`nfe-item-${idx}`}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0"><p className="font-medium">{r.note_name}</p><p className="font-mono text-xs text-muted-foreground">{[r.ean && `EAN ${r.ean}`, r.code && `Cód. ${r.code}`, r.ncm && `NCM ${r.ncm}`].filter(Boolean).join(" · ")}</p></div>
        <div className="text-right"><p className="font-mono text-sm">{fmtQty(r.qty)} {r.unit_raw} × {brl(r.unit_cost)}</p><p className="font-mono text-xs text-muted-foreground">{brl(r.total)}</p></div>
      </div>
      <div className="grid gap-3 sm:grid-cols-[1fr_180px]">
        <Field label="O que fazer"><Sel value={r.action} onChange={(v) => onChange({ action: v })} testId={`nfe-item-action-${idx}`}>{ACTIONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</Sel></Field>
        {!skip && <Field label="Unidades por item da nota" hint="Ex.: caixa com 12 = 12"><Input type="number" min="0" step="any" value={r.factor} onChange={(e) => onChange({ factor: e.target.value })} data-testid={`nfe-item-factor-${idx}`} /></Field>}
      </div>
      {r.action === "existing" && <LinkTarget r={r} idx={idx} catalog={catalog} onChange={onChange} />}
      {r.action.startsWith("new") && <NewTarget r={r} idx={idx} catalog={catalog} onChange={onChange} />}
      {!skip && <Summary r={r} idx={idx} catalog={catalog} />}
    </div>
  );
}
